import { useLocale } from "../contexts/LocaleContext";
import { checkoutTranslations } from "./checkoutTranslations";

const interpolate = (text, variables = {}) => Object.entries(variables).reduce(
  (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)), text,
);

export const useCheckoutLocale = () => {
  const context = useLocale();
  if (context) return context;
  return {
    locale: "nl",
    t: (key, variables) => interpolate(checkoutTranslations.nl[key] || checkoutTranslations.en[key] || key, variables),
    formatNumber: value => new Intl.NumberFormat("nl").format(Number(value || 0)),
    formatDate: value => value ? new Intl.DateTimeFormat("nl", { dateStyle: "medium" }).format(new Date(value)) : "",
  };
};